import { deepCopy } from "../../../../../utils/deepCopy"
import { toast } from "../../../../../utils/messageUtils"

export const deleteDemographicQuestion = (state, payload) => {
    let goals = deleteDemographicQuestionToGoals(state, payload)
    toast.success("Question deleted successfully.")
    return {
        ...state,
        goals: goals
    }
}

const deleteDemographicQuestionToGoals = (state, payload) => {
    let goalsCopy = deepCopy(state.goals)
    let goals = deepCopy(goalsCopy)
    let selectedDemographics = []
    goals.forEach(item => {
        if (item.goalId === "demographics") {
            selectedDemographics = item.questions.filter(
                question => question.staticQuestionId !== payload.question.staticQuestionId
            )
        }
    })
    goalsCopy.forEach(goal => {
        if (goal.goalId ==="demographics") {
            goal.questions = selectedDemographics
        }
    })
    return goalsCopy
}